<template>
	<div class="divcolumn">
		<div class="vertical-text">Consequence</div>
		<div class="grid">
			<div v-for="(row, i) in colors" :key="i" class="row">
				<div v-for="(color, j) in row" :key="j" :class="{ box: true, point: isPoint(i, j) }"
					:style="{ backgroundColor: color, marginBottom: i === colors.length - 1 ? '25px' : '0' }">
					<div :class="[isPoint(i, j) ? 'showpoint' : 'hidedivclass']">
						<div class="circledotclass"></div>
					</div>
					<h5 :class="[isPoint(i, j) ? getTagClass(i, j) : 'hidedivclass']">
						Risk {{ getPointRisk(i, j) }}
					</h5>
				</div>
			</div>
		</div>
		<div>
			<div class="highriskred"><span>High</span></div>
			<div class="moderateriskyellow"><span>Moderate</span></div>
			<div class="lowriskgreen"><span>Low</span></div>
		</div>
		<svg style="position: absolute; top: 10px; left: -70px;" width="550" height="500">
			<defs>
				<marker id="arrowhead" markerWidth="7" markerHeight="5" refX="0" refY="2.5" orient="auto">
					<polygon points="0 0, 7 2.5, 0 5" fill="black" :style="{ opacity: arrowOpacity }" />
				</marker>
			</defs>
			<line v-for="(coords, index) in lineCoordinates" :key="index" :x1="coords.x1" :y1="coords.y1"
				:x2="coords.x2" :y2="coords.y2" stroke="black" stroke-width="2" marker-end="url(#arrowhead)"
				stroke-dasharray="600" stroke-dashoffset="600">
				<animate attributeName="stroke-dashoffset" from="600" to="0" dur="1s" fill="freeze" />
			</line>
		</svg>
	</div>
</template>

<script>
import { mapGetters } from "vuex"
import { riskAPI } from "../api/csr/risk"
import LoadingState from "../consts/LoadingState"

export default {
	props: {
		offsetValue: {
			type: Number,
			default: 0
		}
	},
	data() {
		return {
			arrowOpacity: 0,
			risk: 0,
			index1: 1,
			index: [],
			points: [],
			description: "",
			creator: "",
			horizontal: 0,
			vertical: 0,
			colors: [
				["yellow", "yellow", "yellow", "yellow", "yellow", "yellow", "yellow", "yellow", "yellow", "yellow", "red", "red", "red", "red", "red", "red", "red", "red", "red", "red", "red", "red", "red", "red", "red",],
				["yellow", "yellow", "yellow", "yellow", "yellow", "yellow", "yellow", "yellow", "yellow", "yellow", "red", "red", "red", "red", "red", "red", "red", "red", "red", "red", "red", "red", "red", "red", "red",],
				["yellow", "yellow", "yellow", "yellow", "yellow", "yellow", "yellow", "yellow", "yellow", "yellow", "red", "red", "red", "red", "red", "red", "red", "red", "red", "red", "red", "red", "red", "red", "red",],
				["yellow", "yellow", "yellow", "yellow", "yellow", "yellow", "yellow", "yellow", "yellow", "yellow", "red", "red", "red", "red", "red", "red", "red", "red", "red", "red", "red", "red", "red", "red", "red",],
				["yellow", "yellow", "yellow", "yellow", "yellow", "yellow", "yellow", "yellow", "yellow", "yellow", "red", "red", "red", "red", "red", "red", "red", "red", "red", "red", "red", "red", "red", "red", "red",],
				["green", "green", "green", "green", "green", "yellow", "yellow", "yellow", "yellow", "yellow", "yellow", "yellow", "yellow", "yellow", "yellow", "red", "red", "red", "red", "red", "red", "red", "red", "red", "red",],
				["green", "green", "green", "green", "green", "yellow", "yellow", "yellow", "yellow", "yellow", "yellow", "yellow", "yellow", "yellow", "yellow", "red", "red", "red", "red", "red", "red", "red", "red", "red", "red",],
				["green", "green", "green", "green", "green", "yellow", "yellow", "yellow", "yellow", "yellow", "yellow", "yellow", "yellow", "yellow", "yellow", "red", "red", "red", "red", "red", "red", "red", "red", "red", "red",],
				["green", "green", "green", "green", "green", "yellow", "yellow", "yellow", "yellow", "yellow", "yellow", "yellow", "yellow", "yellow", "yellow", "red", "red", "red", "red", "red", "red", "red", "red", "red", "red",],
				["green", "green", "green", "green", "green", "yellow", "yellow", "yellow", "yellow", "yellow", "yellow", "yellow", "yellow", "yellow", "yellow", "red", "red", "red", "red", "red", "red", "red", "red", "red", "red",],
				["green", "green", "green", "green", "green", "yellow", "yellow", "yellow", "yellow", "yellow", "yellow", "yellow", "yellow", "yellow", "yellow", "yellow", "yellow", "yellow", "yellow", "yellow", "red", "red", "red", "red", "red",],
				["green", "green", "green", "green", "green", "yellow", "yellow", "yellow", "yellow", "yellow", "yellow", "yellow", "yellow", "yellow", "yellow", "yellow", "yellow", "yellow", "yellow", "yellow", "red", "red", "red", "red", "red",],
				["green", "green", "green", "green", "green", "yellow", "yellow", "yellow", "yellow", "yellow", "yellow", "yellow", "yellow", "yellow", "yellow", "yellow", "yellow", "yellow", "yellow", "yellow", "red", "red", "red", "red", "red",],
				["green", "green", "green", "green", "green", "yellow", "yellow", "yellow", "yellow", "yellow", "yellow", "yellow", "yellow", "yellow", "yellow", "yellow", "yellow", "yellow", "yellow", "yellow", "red", "red", "red", "red", "red",],
				["green", "green", "green", "green", "green", "yellow", "yellow", "yellow", "yellow", "yellow", "yellow", "yellow", "yellow", "yellow", "yellow", "yellow", "yellow", "yellow", "yellow", "yellow", "red", "red", "red", "red", "red",],
				["green", "green", "green", "green", "green", "green", "green", "green", "green", "green", "yellow", "yellow", "yellow", "yellow", "yellow", "yellow", "yellow", "yellow", "yellow", "yellow", "yellow", "yellow", "yellow", "yellow", "yellow",],
				["green", "green", "green", "green", "green", "green", "green", "green", "green", "green", "yellow", "yellow", "yellow", "yellow", "yellow", "yellow", "yellow", "yellow", "yellow", "yellow", "yellow", "yellow", "yellow", "yellow", "yellow",],
				["green", "green", "green", "green", "green", "green", "green", "green", "green", "green", "yellow", "yellow", "yellow", "yellow", "yellow", "yellow", "yellow", "yellow", "yellow", "yellow", "yellow", "yellow", "yellow", "yellow", "yellow",],
				["green", "green", "green", "green", "green", "green", "green", "green", "green", "green", "yellow", "yellow", "yellow", "yellow", "yellow", "yellow", "yellow", "yellow", "yellow", "yellow", "yellow", "yellow", "yellow", "yellow", "yellow",],
				["green", "green", "green", "green", "green", "green", "green", "green", "green", "green", "yellow", "yellow", "yellow", "yellow", "yellow", "yellow", "yellow", "yellow", "yellow", "yellow", "yellow", "yellow", "yellow", "yellow", "yellow",],
				["green", "green", "green", "green", "green", "green", "green", "green", "green", "green", "green", "green", "green", "green", "green", "green", "green", "green", "green", "green", "yellow", "yellow", "yellow", "yellow", "yellow",],
				["green", "green", "green", "green", "green", "green", "green", "green", "green", "green", "green", "green", "green", "green", "green", "green", "green", "green", "green", "green", "yellow", "yellow", "yellow", "yellow", "yellow",],
				["green", "green", "green", "green", "green", "green", "green", "green", "green", "green", "green", "green", "green", "green", "green", "green", "green", "green", "green", "green", "yellow", "yellow", "yellow", "yellow", "yellow",],
				["green", "green", "green", "green", "green", "green", "green", "green", "green", "green", "green", "green", "green", "green", "green", "green", "green", "green", "green", "green", "yellow", "yellow", "yellow", "yellow", "yellow",],
				["green", "green", "green", "green", "green", "green", "green", "green", "green", "green", "green", "green", "green", "green", "green", "green", "green", "green", "green", "green", "yellow", "yellow", "yellow", "yellow", "yellow",],
			],
		}
	},
	computed: {
		...mapGetters(["selectedId"]),
		riskOnePoints() {
			const selectedPoints = []
			for (let point of this.points) {
				selectedPoints.push(point)
			}
			return selectedPoints
		},
		lineCoordinates() {
			const arrowLength = 15
			const coordinates = []

			const groupedPoints = this.riskOnePoints.reduce((acc, point) => {
				if (!acc[point.risk]) {
					acc[point.risk] = []
				}
				acc[point.risk].push(point)
				return acc
			}, {})

			Object.values(groupedPoints).forEach((points) => {
				for (let i = 0; i < points.length - 1; i++) {
					const point1 = points[i]
					const point2 = points[i + 1]

					const x1 = (point1.y + this.offsetValue + (this.offsetValue/1.4)) * 20 +3
					const y1 = (point1.x - this.offsetValue) * 20 -10
					const x2 = (point2.y + this.offsetValue+ (this.offsetValue/1.4)) * 20 +3
					const y2 = (point2.x - this.offsetValue) * 20 -10

					const dx = x2 - x1
					const dy = y2 - y1
					const length = Math.sqrt(dx * dx + dy * dy)

					const adjustedX2 = x2 - (dx / length) * arrowLength
					const adjustedY2 = y2 - (dy / length) * arrowLength

					coordinates.push({ x1, y1, x2: adjustedX2, y2: adjustedY2 })
				}
			})

			return coordinates
		}
	},
	watch: {
		selectedId(newID) {
			this.handleIDChange(newID)
		}
	},
	mounted() {
		this.loadRisk(this.selectedId)
		setTimeout(() => {
			this.arrowOpacity = 1
		}, 900)
	},
	methods: {
		handleIDChange(newID) {
			console.log("ID in the Chart:", newID)
			this.points = []  // Clear previous points
			this.vertical = 0
			this.horizontal = 0
			this.index1 = 1
			this.loadRisk(newID)
		},
		isPoint(x, y) {
			return this.points.some((point) => point.x === x && point.y === y)
		},
		addPoint(index1) {
			const point = {
				x: parseInt(Math.abs(this.vertical - 25)),
				y: parseInt(Math.abs(this.horizontal - 1)),
				risk: index1,
			}
			this.points.push(point)
		},
		getPointRisk(x, y) {
			const point = this.points.find((p) => p.x === x && p.y === y)
			return point ? point.risk : ""
		},
		loadRisk(newID) {
			riskAPI.getAll(newID)
				.then((data) => {
					let newdata = data[0]
					for (let entry of newdata) {
						this.vertical = entry.Consequence
						this.horizontal = entry.Probability
						this.risk = this.index1++
						this.addPoint(this.risk)
						this.description = entry.RiskDescription
						this.creator = entry.Creator
						if (entry.UpdatedProbability != null && entry.UpdatedConsequence != null) {
							this.vertical = entry.UpdatedConsequence
							this.horizontal = entry.UpdatedProbability
							this.addPoint(this.risk)
						}
					}
				})
				.catch(error => {
					this.$store.dispatch(
						"loading/" + LoadingState.ACTION_SET_ERROR,
						error,
						{ root: true }
					)
				})
		},
		getTagClass(x, y) {
			const point = this.points.find((p) => p.x === x && p.y === y)
			return point && (point.y > 21) ? "tagclass-left" : "tagclass-right"
		}
	}
}
</script>



<style scoped>
.grid {
	display: flex;
	flex-direction: column;
	width: 550px;
	height: 500px;
}

tr input {
	border: 0px;
}

.row {
	display: flex;
}

.box {
	width: 20px;
	height: 20px;
	border: 1px solid black;
}

.circledotclass {
	width: 10px;
	height: 10px;
	background-color: black;
	border-radius: 50%;
}

.highriskred {
	margin-top: 0px;
	margin-left: -35px;
	width: 25px;
	height: 20px;
	margin-right: 10px;
	background-color: red;
	border: solid 1px black;
}

.highriskred span {
	margin-left: 40px;
}

.moderateriskyellow {
	margin-top: 10px;
	margin-left: -35px;
	width: 25px;
	height: 20px;
	margin-right: 10px;
	background-color: yellow;
	border: solid 1px black;
}

.moderateriskyellow span {
	margin-left: 40px;
}

.lowriskgreen {
	margin-top: 10px;
	margin-left: -35px;
	width: 25px;
	height: 20px;
	margin-right: 10px;
	background-color: green;
	border: solid 1px black;
}

.lowriskgreen span {
	margin-left: 40px;
}

.spanclass1 {
	display: flex;
}

.spanclass2 {
	margin-top: -500px;
	margin-bottom: 500px;
	margin-left: 700px;
	display: flex;
	flex-direction: column;
}

.spanclass2 input {
	border: 1px solid #ccc;
	padding: 10px;
	padding-top: 0px;
}

.spanclass2input1 {
	width: 600px;
	height: 50px;
	padding-top: 0px;
	margin-top: 0px;
	align-items: top;
	font-size: 1.2rem;
}

.spanclass2 h3 {
	margin-left: 0px;
}

.spanclass2input2 {
	display: flex;
	width: 600px;
	height: 200px;
	padding-top: 0px;
	margin-top: 0px;
	align-items: top;
	font-size: 1rem;
}

.hidedivclass {
	display: none;
}

/* .dateonrisktable {
	width: 140px;
} */

.showpoint {
	display: show;
	margin-top: 5px;
	margin-left: 5px;
	transform: scale(1);
}

.divtextclass {
	margin-top: 100px;
	display: flex;
	flex-direction: column;
}

.tagclass-left {
	position: absolute;
	margin-top: -19px;
	margin-left: -50px;
	transform: scale(1);
	background-color: white;
	border-radius: 2px;
	padding: 2px;
	padding-left: 5px;
	border: 1px solid black;
}

.tagclass-right {
	position: absolute;
	margin-top: -19px;
	margin-left: 20px;
	transform: scale(1);
	background-color: white;
	border-radius: 2px;
	padding: 2px;
	padding-left: 5px;
	border: 1px solid black;
}

.black {
	background-color: black;
	border-radius: 50%;
	position: relative;
	width: 10px;
	/* adjust the size of the black dot */
	height: 10px;
	/* adjust the size of the black dot */
	top: 5px;
	/* adjust the vertical position of the black dot */
	left: 5px;
	/* adjust the horizontal position of the black dot */
}

.dotclass {
	margin-top: -20px;
	transform: scale(4);
}

.container {
	display: flex;
	flex-direction: column;
	align-items: center;
	margin-left: 0px;
	margin-top: 0px;
}

.divoftable {
	display: flex;
	flex-direction: column;
	margin-top: 20px;
	display: flex;
	align-items: center;
	flex-direction: column;
}

.tableclass {
	border: 1px solid black;
}

.tdclass {
	margin-left: 0px;
	height: 10px;
	width: 10px;
	padding: 0;
	position: relative;
}

.riskdescriptiontopic {
	width: 200px;
}

.typesofrisktopic {
	width: 250px;
}

.riskownertopic {
	width: 250px;
}

/* .description {
	width: 300px;
} */

/* .typesofrisk {
	width: 150px;
} */

.divcolumn {
	display: flex;
	align-items: left;
	margin-left: -660px;
}

.vertical-text {
	display: flex;
	flex-direction: column;
	margin-top: 100px;
	margin-right: 30px;
	color: #217b7f;
	writing-mode: vertical-rl;
	/* or vertical-lr */
	text-orientation: upright;
	white-space: nowrap;
	font-weight: 1000;
}

.probabilityclass {
	margin-left: -800px;
	margin-top: -250px;
	color: #217b7f;
	letter-spacing: 10px;
	font-weight: 1000;
}

.smallestitem {
	background-color: white;
	height: 20px;
	width: 20px;
	border: 1px solid black;
	display: flex;
	align-items: center;
	justify-content: center;
}

.addpointonmatrixbutton {
	background-color: #217b7f;
	color: white;
	padding-left: 10px;
	padding-right: 10px;
	padding-bottom: 5px
}

.repeatclass {
	display: flex;
	flex-direction: row;
}

/* .point {
    background-color: black;
    border-radius: 50%;
    transform: scale(0.7);
  } */
.label {
	position: absolute;
	top: 100%;
	left: 0;
	width: 100%;
	text-align: center;
	font-size: 10px;
	color: white;
}

.form {
	margin-top: 20px;
	display: flex;
	align-items: center;
}

.form label {
	margin-right: 10px;
}

.form input {
	width: 50px;
	margin-right: 10px;
}

.form button {
	padding: 5px 10px;
	background-color: #2196f3;
	color: white;
	border: none;
	border-radius: 3px;
	cursor: pointer;
}

.form button:hover {
	background-color: #0b7dda;
}

.pnt {

	margin-top: 20px;
}

.pnt h3 {
	margin-bottom: 10px;
}

.pnt ul {
	list-style: none;
	padding: 0;
}


.pnt li {
	margin-bottom: 5px;
}

.esgtable {
	margin-top: 30px;
	display: flex;
	align-items: center;
	margin-left: 0px;
	flex-direction: column;
	margin-right: 0px;
}

.addnewbutton {
	display: flex;
	justify-content: flex-end;
	margin-left: 270px;
}

.addnewriskbutton {
	font-size: 1rem;
	background-color: #217b7f;
	display: flex;
	align-items: flex-start;
	color: white;
	padding: 3px;
}

.rowofheadings {
	font-size: 1.2rem;
}

table {
	border: 1px solid gray;
	width: 123%;
}

th {
	padding: 10px;
	width: 1400px;
	height: 50px;
}

th,
tr {
	text-align: flex-start;
}

tr {
	width: 1300px;
	font-size: 1.5rem;
	border-left: 0.5px solid gray;
	border-right: 0.5px solid gray;
}

th {
	background-color: white;
	color: #217b7f;
	width: 150px;
	margin: 50px;
}

td {
	border-top: 1px solid gray;
	margin: 10px;
}

tr input {
	width: 100px;
	margin: 10px;
	color: #055522;
}

td input {
	font-size: 20px;
}
</style>

<!-- methods: {
          isPoint(x, y) {
            return this.points.some(point => point.x === x && point.y === y);
          },
          getPointLabel(x, y) {
            const point = this.points.find(point => point.x === x && point.y === y);
            return point.label;
          },
          setPoint(x, y, label) {
            const point = { x, y, label };
            const index = this.points.findIndex(p => p.x === x && p.y === y);
            if (index !== -1) {
              this.points.splice(index, 1, point);
            } else {
              this.points.push(point);
            }
          },
          addPoint() {
            const x = parseInt(this.horizontal);
            const y = parseInt(this.vertical);
            if (isNaN(x) || isNaN(y) || x < 1 || x > 25 || y < 1 || y > 25) {
              alert('Invalid coordinates!');
              return;
            }
            const label = prompt('Enter label for the point:');
            if (label) {
              this.setPoint(x, y, label);
            }
          }
        } -->
